import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { MiniLoaderIcon } from "src/utils/icons";

interface SimpleModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  onSubmit: () => void;
  description?: string;
  submitTitleButton?: string;
  cancelTitleButton?: string;
  maxWidth?: "lg" | "sm" | "md" | "xl" | "xs";
  isLoading?: boolean;
  isDelete?: boolean;
  disableValidationButton?: boolean;
}

export const SimpleModal: React.FC<SimpleModalProps> = ({
  open,
  onClose,
  title,
  children,
  onSubmit,
  description,
  submitTitleButton = "Add Endpoint",
  maxWidth = "md",
  isLoading = false,
  isDelete = false,
  disableValidationButton = false,
  cancelTitleButton = "Cancel"
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      aria-labelledby="simple-modal-title"
      maxWidth={maxWidth}
      fullWidth
    >
      {title && (
        <DialogTitle id="simple-modal-title">
          <div className="flex flex-col items-start">
            <div className="flex flex-row w-full text-lg font-semibold text-gray-500">
              {title}
              {isLoading && (
                <div className="flex flex-1 w-full flex-row-reverse">
                  <div>
                    {MiniLoaderIcon()}
                    <span className="sr-only"></span>
                  </div>
                </div>
              )}
            </div>
            {description && (
              <div className="text-lg !text-[12px] text-gray-500">
                <p>{description}</p>
              </div>
            )}
          </div>
        </DialogTitle>
      )}
      <DialogContent>{children}</DialogContent>
      <hr className="border-t border-gray-200 mb-4" />
      <DialogActions className="mb-4 mr-4">
        <Button
          onClick={onClose}
          color="primary"
          className="!text-[#333333] !border !border-[#333333]"
        >
          {cancelTitleButton}
        </Button>
        <Button
          className={`!text-[#fff] !text-semibold flex xs:h-[40px] sm:h-[40px] md:h-[40px] lg:h-[40px] xl:h-[40px] xs:p-[8px] sm:p-[8px]  md:p-[15px] lg:p-[15px] xl:p-[15px] justify-center items-center gap-[8px] rounded-[40px] [background:var(--main-gradient,linear-gradient(90deg,#145BF0_0%,#1DC66D_100%))] ${isLoading ? "opacity-50" : ""}`}
          onClick={onSubmit}
          disabled={isLoading || disableValidationButton}
        >
         {!isDelete && <i className="bi bi-plus"></i>}
          {submitTitleButton}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
